import { render, staticRenderFns } from "./MedicationFilter.vue?vue&type=template&id=0e8edfe1"
import script from "./MedicationFilter.vue?vue&type=script&lang=js"
export * from "./MedicationFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports